import { render, staticRenderFns } from "./EnterpriseDataTabComponent.vue?vue&type=template&id=bf269920&scoped=true"
import script from "./EnterpriseDataTabComponent.js?vue&type=script&lang=js&external"
export * from "./EnterpriseDataTabComponent.js?vue&type=script&lang=js&external"
import style0 from "./EnterpriseDataTabComponent.vue?vue&type=style&index=0&id=bf269920&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf269920",
  null
  
)

export default component.exports